import { ReportData } from "@/types/report"
import axios, { AxiosInstance } from "axios"

class ReportApi {
	private axios: AxiosInstance;

	constructor () {
		this.axios = axios.create({
			baseURL: process.env.VUE_APP_HTTP_API_URI,
			withCredentials: true,
			headers: {
				Accept: "application/json, text/javascript, */*; q=0.01",
				"Content-Type": "application/json"
			}
		})
	}

	public async reportData (reportDataId: string): Promise<ReportData> {
		return (await this.axios.get(`/report/reportData/${reportDataId}`)).data
	}
}

const api = new ReportApi()
export default api
